exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-on .cell[data-v-7bff0c98]{overflow:visible;overflow-x:visible;overflow-y:visible}.cell-img .cell[data-v-7bff0c98]{line-height:0}.avatar-uploader-icon[data-v-7bff0c98]{font-size:28px;color:#8c939d;width:90px;height:90px;line-height:90px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px;border-color:#409EFF}.img-tips[data-v-7bff0c98]{display:inline-block;color:#999999;font-size:12px}\n", ""]);

// exports
